import React from "react";
import { Container } from "reactstrap";
import BreadCrumb from "Components/Common/BreadCrumb";
import AllContractorDuplicates from "./AllContractorDuplicates";
import { usePageActivity } from "Components/Hooks/UsePageActivity";
import { useLocation } from "react-router-dom";

const Contractors = () => {
  const location = useLocation();
  usePageActivity(location.pathname, "ContractorDuplicates");

  document.title = "Contractor Duplicates | CIMS";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Contractor Duplicates"
            pageTitles={[{ title: "Dashboard", link: "/dashboard" }]}
          />
          <AllContractorDuplicates />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Contractors;
